//#region src/api/userActions/const.ts
const userActionStartByApiCallEventName = "faroApiCall";
const userActionStart = "user_action_start";
const UserActionImportance = {
	Normal: "normal",
	Critical: "critical"
};
const userActionEventName = "faro.user.action";
//#endregion
export { UserActionImportance, userActionEventName, userActionStart, userActionStartByApiCallEventName };

//# sourceMappingURL=const.js.map